/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the candidate menu is ordered. providers is an unordered filter over which providers are eligible; strategy alone decides ordering. capacity_optimized, the default, groups by a curated provider precedence and sorts by price within each group. lowest_cost orders by price alone across whichever providers remain eligible.
 */
export const ComputePlacementStrategy = {
  CapacityOptimized: "capacity_optimized",
  LowestCost: "lowest_cost",
} as const;
/**
 * How the candidate menu is ordered. providers is an unordered filter over which providers are eligible; strategy alone decides ordering. capacity_optimized, the default, groups by a curated provider precedence and sorts by price within each group. lowest_cost orders by price alone across whichever providers remain eligible.
 */
export type ComputePlacementStrategy = ClosedEnum<
  typeof ComputePlacementStrategy
>;

/** @internal */
export const ComputePlacementStrategy$inboundSchema: z.ZodNativeEnum<
  typeof ComputePlacementStrategy
> = z.nativeEnum(ComputePlacementStrategy);
/** @internal */
export const ComputePlacementStrategy$outboundSchema: z.ZodNativeEnum<
  typeof ComputePlacementStrategy
> = ComputePlacementStrategy$inboundSchema;
